import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getHeaders } from '../config/api';

const useUpdates = (apiUrl, options = {}) => {
  const { i18n } = useTranslation();
  const { enableApi = false } = options;
  
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Traduire selon la langue actuelle
  const translateUpdates = (data, lang) => {
    if (!Array.isArray(data)) return data;
    
    return data.map(update => {
      if (update.translations?.[lang]) {
        const t = update.translations[lang];
        return {
          ...update,
          title: t.title || update.title,
          description: t.description || update.description,
          linkText: t.linkText || update.linkText,
          subtitle: t.subtitle || update.subtitle
        };
      }
      return update;
    });
  };

  // Récupérer et traduire les données
  useEffect(() => {
    if (!enableApi) return;
    
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const normalizedLang = i18n.language.split('-')[0]; // fr-FR -> fr
        const url = `${apiUrl}?lang=${normalizedLang}`;
        // console.log('🌐 Fetching updates from:', url);
        
        const response = await fetch(url, {
          headers: getHeaders({ 'Accept-Language': i18n.language })
        });
        
        //console.log('📡 Response status:', response.status);
        
        if (!response.ok) throw new Error('Erreur réseau');
        
        const data = await response.json();
        //console.log('📊 Raw data:', data);  
        
        const updates = Array.isArray(data) ? data : data.body || data.updates || [];
        //console.log('📋 Updates array:', updates);
        
        const translated = translateUpdates(updates, normalizedLang);
        // console.log('🌍 Translated updates:', translated);
        
        setUpdates(translated);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [apiUrl, enableApi, i18n.language]);

  return {
    updates,
    loading,
    error,
    refresh: () => window.location.reload()
  };
};

export default useUpdates; 